/**
 * Removes references that are no longer in the scene.
 * @param {Q3DataStructure} data Data to filter.
 * @param {Object} objects Tree to filter with.
 * @param {Object[]} references Reference object information.
 */
function filterReferences(data, objects, references) {
    references.forEach(refId => {
        const refObjs = objects.filter(object => data.assets.objects[object.uuid].referenceId === refId);
        const isFullyDeleted = refObjs.every(refObj => refObj.isFullyDeleted);

        if (isFullyDeleted) {
            const index = data.assets.references.indexOf(refId);

            if (index >= 0)
                data.assets.references.splice(index, 1);
        }
    });
}

/**
 * Recursively removes data Q3 data object using tree filter.
 * @param {Q3DataStructure} data Data to filter.
 * @param {Object} objects Tree to filter with.
 */
function recursiveFilter(data, objects) {
    objects.forEach(object => {
        if (object.deleted || object.isFullyDeleted) {
            delete data.assets.objects[object.uuid];

            if (data.slides) {
                const slides = "slides" in data ? data.slides : [data.slide];

                slides.forEach(slide => delete slide.animation[object.uuid]);
            }
        }

        recursiveFilter(data, object.children);
    });
}

function filterBrokenAnimations(data) {
    Object
        .keys(data.assets.animations || {})
        .forEach(animationUuid => {
            const animation = data.assets.animations[animationUuid];

            if (animation.deleted)
                delete data.assets.animations[animationUuid];
        });
}

module.exports = { filterReferences, recursiveFilter, filterBrokenAnimations };